/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, total: NonNullable<unknown> }} Team_Share_Access_PartialInputs */

const en_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const fr_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const de_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const it_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const ru_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const es_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const zh_cn2_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const ja_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const hi_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

const pt_pt2_team_share_access_partial = /** @type {(inputs: Team_Share_Access_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
};

/**
* | output |
* | --- |
* | "{selected} of {total} event groups" |
*
* @param {Team_Share_Access_PartialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_access_partial = /** @type {((inputs: Team_Share_Access_PartialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Access_PartialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_access_partial(inputs)
	if (locale === "de") return de_team_share_access_partial(inputs)
	if (locale === "it") return it_team_share_access_partial(inputs)
	if (locale === "ru") return ru_team_share_access_partial(inputs)
	if (locale === "es") return es_team_share_access_partial(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_access_partial(inputs)
	if (locale === "ja") return ja_team_share_access_partial(inputs)
	if (locale === "hi") return hi_team_share_access_partial(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_access_partial(inputs)
	return en_team_share_access_partial(inputs)
});